import { useQuery } from '@tanstack/react-query'

import HyperSDK from '@/lib/utils/hyper.sdk.utils'

type UseHyperCandleProps = {
  coin: string
  interval: string
  startTime: number
  endTime: number
  limit?: number
}

export function useHyperCandle({ coin, interval, startTime, endTime, limit }: UseHyperCandleProps) {
  return useQuery({
    queryKey: ['hyperCandle', coin, interval, startTime, endTime, limit],
    queryFn: async () => {
      const infoClient = await HyperSDK.info()
      const candles = await infoClient.getCandleSnapshot(coin, interval, startTime, endTime)
      return candles
    },
    enabled: !!coin && !!interval && startTime > 0 && endTime > 0 && startTime < endTime,
  })
}
